<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template #custom_actions>
        <div class="text-right">
          <action-button
            text="Regresar"
            class="mr-2"
            variant="outline-success"
            i="fas fa-arrow-circle-left"
            @click="$router.go(-1)"
          />
          <action-button
            text="Someter Pedido"
            variant="outline-success"
            i="fad fa-share-square"
            @click="submit"
          />
        </div>
      </template>
    </page-header>

    <validation-observer ref="formValidatorSearch">
      <filter-manager
        ref="filter"
        v-model="this.filters"
        :display-advanced="false"
        items-container-class="flex-wrap"
        actions-container-class="col-sm-3 ml-0 mr-0 text-right"
        :filters="filtersHeader"
        :search-text="null"
        @search="onSearch"
      >
        <div class="col-12 col-md-auto">
          <action-button
            text="Buscar"
            variant="success"
            class="fr px-4 search mt-1"
            i="fas fa-search"
            :style="{ width: isMobile ? '100%' : '' }"
            @click="onSearch"
          />
        </div>
      </filter-manager>
    </validation-observer>

    <custom-separator
      text="Selección de Libros"
      class="my-4 custom-separator-line"
    />

    <BookRequestSearchResultRow
      v-for="(request, idx) in requestBooksResult"
      :key="idx + 'BookRequest'"
      :value="request"
      :academic-year-id="filters.academicYear.id"
    />
    <div class="row">
      <div class="col-12 pt-0">
        <pagination
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"
          @pagination-go-page="onPageChanged"
        />
      </div>
    </div>

    <CustomResultNotFound
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No se ha encontrado resultado de libros para este periodo"
    />

    <Error
      v-if="invalidSubmit"
      variant="no-border"
      :message="collections.messages['25041']"
    />

    <custom-separator
      v-if="selectedBooks.length > 0"
      text="Libros Seleccionados"
      class="my-4 custom-separator-line"
    />

    <SelectedBookResultRow
      v-for="(request, idx) in selectedBooks"
      ref="selectedBookRow"
      :key="idx + 'SelectedBook'"
      :value="request"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import FilterManager from 'FilterManager';
import CustomResultNotFound from 'custom-result-not-found';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import ResourcesService from '@/services/resources.js';
import {
  getAcademicYears,
  getBooksForOrders,
  getStudentPendingBooksOrders,
  documentBooksOrders,
  submit,
} from '@/modules/books-requests/api';
import BookRequestSearchResultRow from './components/CompBookRequestSearchResultRow/BookRequestSearchResultRow';
import SelectedBookResultRow from './components/CompBookRequestSearchResultRow/SelectedBookResultRow';
import store from '@/store/index';
import Pagination from 'pagination';
import { studentBookStatus } from '@/utils/constants/book/studentBookStatus';
import Error from 'custom-error';

export default {
  name: 'BookRequestSearch',
  mixins: [mixAlert, mixWait],
  components: {
    PageHeader,
    CustomSeparator,
    ActionButton,
    FilterManager,
    CustomResultNotFound,
    BookRequestSearchResultRow,
    SelectedBookResultRow,
    Pagination,
    Error,
  },
  data() {
    return {
      filters: {
        searchText: null,
        academicYear: null,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      collections: {
        academicYears: [],
        messages: [],
      },
      requestBooksResult: [],
      selectedBooks: [],
      invalidSubmit: false,
    };
  },
  methods: {
    async onSearch({ pageIndex = 1, fromSelectedBooks = false } = {}) {
      if (!fromSelectedBooks) {
        const isValid = await this.$refs.formValidatorSearch.validate();
        if (!isValid) {
          this.ShowToast('Alerta', 'Información Incompleta.', 'error');
          return;
        }
      }

      await getBooksForOrders({
        academicYearId: this.filters.academicYear.id,
        searchField: this.filters.searchText,
        studentSieId: store.getters.SelectedStudent.studentId,
        pageSize: this.pagination.perPage,
        pageIndex: pageIndex > 1 ? this.pagination.currentPage : pageIndex,
      }).then((res) => {
        this.requestBooksResult = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      await this.onSearch({ pageIndex: currentPage });
    },
    async addToSelectedBooks(value) {
      this.requestBooksResult.splice(value, 1);

      await this.getStudentPendingBooksOrders();
      this.invalidSubmit = false;
    },
    async loadAcademicYears() {
      await getAcademicYears()
        .then((response) => {
          if (response.data.length > 0) {
            this.collections.academicYears = response.data;
            this.filters.academicYear = response.data[0];
          }
        })
        .catch((errm) => {
          this.ShowToast(errm.message, '', 'error');
        });
    },
    async getStudentPendingBooksOrders() {
      await getStudentPendingBooksOrders(
        store.getters.SelectedStudent.studentId,
        this.filters.academicYear.id
      ).then(({ data }) => {
        this.selectedBooks = data;
      });
    },
    async submit() {
      let isValid =
        this.selectedBooks.some(
          (x) => x.statusId == studentBookStatus.PendientePedido
        ) && this.selectedBooksValid();

      if (!isValid) {
        this.invalidSubmit = !this.selectedBooks.some(
          (x) => x.statusId == studentBookStatus.PendientePedido
        );
        this.ShowToast(
          'Información Incompleta:',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const confirm = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea someter el pedido de libros?',
        'Sí',
        'No'
      );

      if (!confirm) {
        return;
      }

      this.selectedBooks.forEach((x) => {
        x.requestReasonCode = x.requested ? x.requestReason?.id : null;
        x.requestReason = null;
      });

      await documentBooksOrders(this.selectedBooks)
        .then((res) => {
          if (res.status == 200) {
            submit(this.selectedBooks)
              .then((result) => {
                if (result.status == 200) {
                  this.selectedBooks = [];
                  this.ShowToast(
                    'Proceso exitoso.',
                    'El pedido de libros fue sometido exitosamente.',
                    'success'
                  );
                }
              })
              .catch((err) => {
                if (err && err.response && err.response.data) {
                  this.ShowToast('Error', err.response.data.message, 'error');
                } else {
                  this.ShowToast('Error', err.message, 'error');
                }
              });
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    selectedBooksValid() {
      let selectedBooksRowValidations = [];
      this.$refs.selectedBookRow.forEach((book) => {
        selectedBooksRowValidations.push(book.validateBeforeSubmit());
      });

      return selectedBooksRowValidations.every((x) => x);
    },
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    showNotResults() {
      return this.requestBooksResult.length == 0;
    },
    page() {
      return {
        icon: 'fas fa-book-open',
        title: 'Pedido de Libros',
        routes: ['Inicio', 'Libros', 'Pedido de Libros'],
      };
    },
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filters.academicYear,
          placeholder: 'Seleccione el año',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-3 col-md-3 ml-0 mr-0',
          classContainer: 'w-100',
          mapParentValue: this.filters.academicYear == null,
          error: this.collections.messages['R03200049']
            ? this.collections.messages['R03200049'].split(' (')[0]
            : null,
          validations: 'required',
        },
        {
          name: 'searchText',
          component: 'CustomInput',
          placeholder: 'Escriba Grado, Materia o Título',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-md my-1',
          type: 'text',
          error:
            'Favor entrar el grado, materia o titulo para continuar con la búsqueda.',
          validations: 'required',
        },
      ];
    },
  },
  async mounted() {
    await this.loadAcademicYears();
    this.collections.messages = await ResourcesService.LoadValidationMessages([
      'R03200049',
      '25041',
    ]);
    await this.getStudentPendingBooksOrders();
  },
};
</script>

<style scoped>
.success {
  max-height: 38px !important;
}
</style>
